const MONTHS = {
  ru: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ],
  kz: [
    "Қаңтар",
    "Ақпан",
    "Наурыз",
    "Сәуір",
    "Мамыр",
    "Маусым",
    "Шілде",
    "Тамыз",
    "Қыркүйек",
    "Қазан",
    "Қараша",
    "Желтоқсан",
  ],
};

const WEEKDAYS = {
  ru: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
  kz: ["Дс", "Сс", "Ср", "Бс", "Жм", "Сб", "Жс"],
};

function langFromLocale(locale) {
  const l = String(locale || "ru").toLowerCase();
  return l.startsWith("kk") || l.startsWith("kz") ? "kz" : "ru";
}

export function weekdayLabels(locale) {
  return WEEKDAYS[langFromLocale(locale)];
}

export function monthYearLabel(locale, month, year) {
  const lang = langFromLocale(locale);
  const name = MONTHS[lang][month - 1] || "";
  if (!year) return name;
  return lang === "kz" ? `${year} ж. ${name}` : `${name} ${year}`;
}
